import $ from 'jquery';
export var phoneRequired = function phoneRequired() {
  $('form[name="O_Cignacom_030418_Notifications_Form"] #contact-checkbox').click(function () {
    $('.business-phone-input').toggleClass('d-none');
    $('.contact-disclaimer').toggleClass('d-none');
  });
};

var setFMLASuccessMsg = function setFMLASuccessMsg() {
  var solutionsId = $('form[name="CGI-FMLA-ADA"] select[id^="Solutions"]');
  $('form[name="CGI-FMLA-ADA"]').on('submit', function () {
    if ($(solutionsId).find(':selected').attr('id') === 'fmla') {
      $('#fmlaSuccess').attr('class', 'd-block');
      $('#normalSuccess').attr('class', 'd-none');
    }
  });
};

export default (function () {
  phoneRequired();
  setFMLASuccessMsg();
});